import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaChevronLeft, FaChevronRight, FaWhatsapp } from 'react-icons/fa';
import styles from './thayanyvianaa_procedimentos.module.scss';
import Brow1 from './src/procedimentos/brow1.png';
import Brow2 from './src/procedimentos/brow2.png';
import LashLifting1 from './src/procedimentos/lashlifting1.png';
import LashLifting2 from './src/procedimentos/lashlifting2.png';
import LashLifting3 from './src/procedimentos/lashlifting3.png';
import DesignPersonalizado1 from './src/procedimentos/designpersonalizado1.png';
import Tintura1 from './src/procedimentos/tintura1.png';
import Reconstrucao1 from './src/procedimentos/reconstrucao1.png';

const WHATSAPP_NUMBER = '5517981302893';

type Procedimento = {
    titulo: string;
    descricao: string;
    durabilidade?: string;
    imagens: string[];
    whatsappMessage: string;
};

const procedimentos: Procedimento[] = [
    {
        titulo: 'Brow lamination',
        descricao:
            'Técnica moderna que entrega preenchimento, organização dos fios, respeitando totalmente a naturalidade da sua sobrancelha.',
        durabilidade: '45 a 60 dias',
        imagens: [Brow1, Brow2],
        whatsappMessage:
            'Olá, tudo bem? Vim pelo link na bio e gostaria de informações sobre Brow lamination.',
    },
    {
        titulo: 'Lash Lifting',
        descricao:
            'Procedimento que realça os seus cílios naturais, proporcionando mais curvatura, alongamento e definição. Perfeito para quem quer praticidade e não quer depender de rímel todos os dias.',
        durabilidade: 'Até 2 meses',
        imagens: [LashLifting1, LashLifting2, LashLifting3],
        whatsappMessage:
            'Olá, tudo bem? Vim pelo link na bio e gostaria de informações sobre Lash Lifting.',
    },
    {
        titulo: 'Design Personalizado',
        descricao:
            'Técnica que cria um desenho de sobrancelha harmonioso, respeitando o seu formato de rosto e suas características naturais. Inclui limpeza dos fios e alinhamento estratégico, valorizando e realçando o olhar.',
        durabilidade: '15 a 20 dias (dependendo do crescimento dos fios)',
        imagens: [DesignPersonalizado1],
        whatsappMessage:
            'Olá, tudo bem? Vim pelo link na bio e gostaria de informações sobre Design Personalizado.',
    },
    {
        titulo: 'Design com Tintura',
        descricao:
            'Ideal para quem deseja um leve preenchimento nas sobrancelhas de forma natural, sem precisar recorrer à henna. A tintura age nos fios, intensificando a cor e ajudando a disfarçar falhas e fios brancos.',
        durabilidade: 'Nos fios: até 30 dias\nNa pele: até 7 dias',
        imagens: [Tintura1],
        whatsappMessage:
            'Olá, tudo bem? Vim pelo link na bio e gostaria de informações sobre Design com Tintura.',
    },
    {
        titulo: 'Reconstrução de Sobrancelhas',
        descricao:
            'Tratamento feito por sessões, com produtos e ativos específicos que estimulam a recuperação dos fios. Indicado para quem já teve sobrancelhas mais cheias e hoje sofre com falhas ou perda de volume.',
        imagens: [Reconstrucao1],
        whatsappMessage:
            'Olá, tudo bem? Vim pelo link na bio e gostaria de informações sobre Reconstrução de Sobrancelhas.',
    },
];

const getWhatsappUrl = (message: string) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

interface CardProcedimentoProps {
    titulo: string;
    descricao: string;
    durabilidade?: string;
    imagens: string[];
    whatsappMessage: string;
}

const CardProcedimento: React.FC<CardProcedimentoProps> = ({
    titulo,
    descricao,
    durabilidade,
    imagens,
    whatsappMessage,
}) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const hasMultipleImages = imagens.length > 1;

    const prevImage = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (!hasMultipleImages) return;
        setCurrentIndex((prev) => (prev === 0 ? imagens.length - 1 : prev - 1));
    };

    const nextImage = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (!hasMultipleImages) return;
        setCurrentIndex((prev) => (prev === imagens.length - 1 ? 0 : prev + 1));
    };

    return (
        <article className={styles.card}>
            <div className={styles.carouselContainer}>
                <img src={imagens[currentIndex]} alt={titulo} className={styles.carouselImage} />
                {hasMultipleImages && (
                    <>
                        <button
                            type="button"
                            className={`${styles.carouselBtn} ${styles.prevBtn}`}
                            onClick={prevImage}
                            aria-label="Imagem anterior"
                        >
                            <FaChevronLeft />
                        </button>
                        <button
                            type="button"
                            className={`${styles.carouselBtn} ${styles.nextBtn}`}
                            onClick={nextImage}
                            aria-label="Próxima imagem"
                        >
                            <FaChevronRight />
                        </button>
                        <div className={styles.indicators}>
                            {imagens.map((_, idx) => (
                                <span
                                    key={idx}
                                    role="button"
                                    tabIndex={0}
                                    className={`${styles.dot} ${idx === currentIndex ? styles.active : ''}`}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setCurrentIndex(idx);
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            setCurrentIndex(idx);
                                        }
                                    }}
                                    aria-label={`Ir para imagem ${idx + 1}`}
                                />
                            ))}
                        </div>
                    </>
                )}
            </div>

            <h3 className={styles.cardTitle}>{titulo}</h3>
            <p className={styles.descricao}>{descricao}</p>
            {durabilidade ? (
                <p className={styles.durabilidade}>
                    <span className={styles.durabilidadeLabel}>Durabilidade:</span>{' '}
                    {durabilidade.split('\n').map((line, i) => (
                        <React.Fragment key={i}>
                            {i > 0 && <br />}
                            {line}
                        </React.Fragment>
                    ))}
                </p>
            ) : null}

            <a
                href={getWhatsappUrl(whatsappMessage)}
                className={styles.whatsappBtn}
                target="_blank"
                rel="noopener noreferrer"
            >
                <FaWhatsapp aria-hidden />
                <span>Falar no WhatsApp</span>
            </a>
        </article>
    );
};

const Thayanyvianaa_procedimentos: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.thayanyvianaa_procedimentos}>
            <div className={styles.header}>
                <Link
                    to="/thayanyvianaa"
                    state={{ skipLoader: true }}
                    className={styles.backButton}
                    aria-label="Voltar ao cartão digital"
                >
                    <FaArrowLeft />
                </Link>
                <h1 className={styles.pageTitle}>Procedimentos</h1>
            </div>

            <div className={styles.lista}>
                {procedimentos.map((item) => (
                    <CardProcedimento
                        key={item.titulo}
                        titulo={item.titulo}
                        descricao={item.descricao}
                        durabilidade={item.durabilidade}
                        imagens={item.imagens}
                        whatsappMessage={item.whatsappMessage}
                    />
                ))}
            </div>
        </div>
    );
};

export default Thayanyvianaa_procedimentos;
